import { content as en } from "./en";
import { content as pt } from "./pt";

export const content = {
  ...en,
  ...pt,
};
